/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { LegalEntityManagementModule } from '@well/common-libs/legal-entity-management/shared';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CompanyDetailsDtoModel } from '@well/domain';
import { FormsModule } from '@angular/forms';
import { LegalEntityModel } from '@well/common-libs/legal-entity-management/domain-model';
import { TermsAndConditionsService } from '../terms-and-conditions/service/terms-and-conditions.service';
import { LoggedInContextService, WellContextService } from '@well/shared-providers';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ErrorSeverityEnum } from '@irian-ro/shared-components-module';
import { LoggedInUser } from '@irian-ro/util-user';

@Component({
  selector: 'well-company-details-validation-page',
  standalone: true,
  imports: [CommonModule, ButtonModule, CheckboxModule, LegalEntityManagementModule, TranslateModule, FormsModule],
  templateUrl: './company-details-validation-page.component.html',
  styleUrl: './company-details-validation-page.component.scss',
})
export class CompanyDetailsValidationPageComponent implements OnInit {
  companyDetailsDtoModel: CompanyDetailsDtoModel | null = null;

  termsAndConditionsService = inject(TermsAndConditionsService);
  wellContextService = inject(WellContextService);
  loggedInContextService = inject(LoggedInContextService);
  translateService = inject(TranslateService);
  router = inject(Router);
  route = inject(ActivatedRoute);
  messageService = inject(MessageService);

  ngOnInit() {
    this.termsAndConditionsService.getMyCompanyProfile().subscribe((res) => {
      this.companyDetailsDtoModel = res.data;
    });
  }

  onValidateCompanyDetails(legalEntity: LegalEntityModel) {
    Object.assign(this.companyDetailsDtoModel?.legalEntityDTO, legalEntity);
    this.termsAndConditionsService.updateValidCompanyDetails(this.companyDetailsDtoModel).subscribe(() => {
      this.loggedInContextService.clearLoggedInUser();
      this.loggedInContextService.getLoggedInContextFromServer().subscribe((user: LoggedInUser) => {

        this.translateService.use(user.language);

        this.messageService.add({
          severity: ErrorSeverityEnum.success,
          summary: this.translateService.instant('shell-app.companyValidation.validatedMessage'),
          key: 'global-error',
        });

        const returnUrl: string = this.route.snapshot.queryParams['returnUrl'] || '/';
        this.router.navigate([returnUrl]);
      });
    });
  }
}
